import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import routing from "routing";
import isMobile from "src/helpers/isMobile";
import CourseIcon from "src/images/Icons/newIcons/navigation/courses.svg";

import { hasLimitedAccess } from "../../helpers/getPermissions";
import { useGetCourses } from "../../hooks/useCourses";
import Box from "../Default/Main/Box";
import { ShortLimitedAccess } from "../NewComponents/LimitedAccess";
import ExamsShortViewSkeleton from "../NewComponents/Skeletons/ExamsShortView";
import CourseView from "../NewComponents/Views/ScoreViews/CourseView";
import EmptyBox from "./EmptyBox";
import { Header } from "./ExamsBox/ExamsBox";

function Courses() {
	const { t } = useTranslation();
	const { isLoading, data: courses } = useGetCourses();
	const history = useHistory();

	const getContent = () => {
		const rows = courses.filter(({ lessons }: { lessons: { status: string }[] }) =>
			lessons.some((lesson: { status: string }) =>
				["incomplete", "waiting"].includes(lesson.status),
			),
		);

		if (isMobile()) {
			const row = rows[0] || courses[0];

			return <CourseView row={row} className="mb-8" />;
		}

		return courses
			.slice(0, 2)
			.map((course: { id: string }) => (
				<CourseView row={course} key={course.id} className="mb-8" />
			));
	};

	const renderContent = () => {
		if (isLoading) {
			return <ExamsShortViewSkeleton />;
		}

		if (hasLimitedAccess()) {
			return <ShortLimitedAccess />;
		}

		if (!courses || courses.length === 0) {
			return (
				<EmptyBox
					title={t("table.courses.empty.title")}
					subtitle="Dodaj nowy kurs korzystając z przycisku w prawym rogu lub z panelu po lewej stronie."
				/>
			);
		}

		return getContent();
	};

	return (
		<Box
			Header={
				<Header
					title={t("table.courses.title")}
					icon={<CourseIcon className={cx("icon-super-big icon-logo")} />}
					onShowAll={() => {
						history.push(routing.paths.userCourses);
					}}
					onCreate={() => {
						history.push(routing.paths.pickCourseType);
					}}
					onCreateTooltip={t("tooltips.createNewCourse")}
					onShowAllTooltip={t("tooltips.showAllCourses")}
				/>
			}
		>
			<div>{renderContent()}</div>
		</Box>
	);
}

export default Courses;
